import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { Link } from '@bd/bdcore-named-routes';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import { css } from '@bd/bdui-styles/emotion';
import { colors, typography } from '../../../styles';
// import PageSectionHeading from '../../PageSectionHeading';

const styles = css`
  width: 100%;
  background-color: ${colors.white};
  .CTA_wrapper {
    display: flex;
    flex-direction: column;
    padding: 75px 0;
  }
  .CTA_header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: ${colors.bodyDarkest};
    z-index: 2;
    position: relative;
    padding: 30px;
    @media(min-width: 992px) {
      width: 20%;
      flex-basis: 20%;
      justify-content: center;
      align-items: flex-start;
      padding: 0 0 0 30px;
      overflow: visible;
    }
  }
  .CTA_headerTitle {
    font-size: 36px;
    font-family: ${typography.Serif};
    color: ${colors.white};
    line-height: 1;
    white-space: nowrap;
    text-align: center;
    @media(min-width: 480px) {
      font-size: 48px;
    }
    @media(min-width: 992px) {
      font-size: 130px;
      text-align: left;
      line-height: .8;
    }
  }
  .CTA_headerSubTitle {
    font-size: 24px;
    white-space: nowrap;
    display: block;
    position: relative;
    @media(min-width: 480px) {
      font-size: 36px;
    }
    @media(min-width: 992px) {
      font-size: 48px;
    }
    &::after {
      content: '';
      display: block;
      position: relative;
      width: 75px;
      height: 4px;
      background-color: ${colors.brand4};
      margin: 20px auto 0 auto;
      @media(min-width: 992px) {
        margin: 25px 0 0 0;
      }
    }
  }
  .CTA_content {
  }
  .CTA_button {
    width: 100%;
    height: 200px;
    position: relative;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: ${typography.Condensed};
    font-weight: 700;
    color: ${colors.white};
    font-size: 32px;
    letter-spacing: 2px;
    text-transform: uppercase;
    @media(min-width: 992px) {
      width: 100%;
      height: 280px;
    }
    &::after {
      content: '';
      display: block;
      position: absolute;
      z-index: 1;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      background-color: ${colors.black};
      opacity: .35;
      transition: all .3s ease;
    }
    &:hover, &:focus {
      &::after {
        opacity: 0;
      }
      .CTA_buttonTitle {
        text-shadow: 0 2px 8px rgba(0,0,0,.5);
      }
      .CTA_buttonTitle::after {
        opacity: 1;
      }
    }
  }
  .CTA_buttonTitle {
    position: relative;
    z-index: 2;
    text-shadow: 0 2px 5px rgba(0,0,0,.25);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .CTA_buttonCount {
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${colors.white};
    font-family: ${typography.Condensed};
    font-size: 48px;
    line-height: 1;
  }
`;


function CtaBanner({ content, communities, homes, plans }) {
  return (
    <div className={styles}>
      <div className="CTA_wrapper">
        {/* <PageSectionHeading h3={get(content, '[0].headline')} /> */}
        <div className="CTA_content">
          <div className="container">
            <div className="row">
              {
                get(content, '[0].cta_items', []).map(item => (
                  <div className="col-md-4" key={get(item, 'title')}>
                    <Link
                      name={get(item, 'route')}
                      className="CTA_button"
                      style={{ backgroundImage: `url(${buildThumbnailUrl(get(item, 'image.contentUrl'), { width: 1300, height: 1300 })})` }}
                    >
                      <div className="CTA_buttonTitle">
                        {
                          get(item, 'route') === 'communities' &&
                          get(item, 'show_count_for_properties') &&
                          <div className="CTA_buttonCount">{communities.length}</div>
                        }
                        {
                          get(item, 'route') === 'homes' &&
                          get(item, 'show_count_for_properties') &&
                          <div className="CTA_buttonCount">{homes.length}</div>
                        }
                        {
                          get(item, 'route') === 'plans' &&
                          get(item, 'show_count_for_properties') &&
                          <div className="CTA_buttonCount">{plans.length}</div>
                        }
                        {get(item, 'title')}
                      </div>
                    </Link>
                  </div>
                ))
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}


CtaBanner.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
  communities: PropTypes.arrayOf(PropTypes.object).isRequired,
  homes: PropTypes.arrayOf(PropTypes.object).isRequired,
  plans: PropTypes.arrayOf(PropTypes.object).isRequired,
};

CtaBanner.defaultProps = {
};

export default withData({
  communities: 'all',
  homes: 'all',
  plans: 'all',
},
  {
    isRequired: {
      communities: true,
      homes: true,
      plans: true,
    },
  },
)(CtaBanner);



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/CTABanner.section.js